import React from 'react';
import type { GlobalAttributesT, XstyledProps } from '@elliemae/ds-props-helpers';
import {
  useGetGlobalAttributes,
  useGetXstyledProps,
  useMemoMergePropsWithDefault,
  useValidateTypescriptPropTypes,
} from '@elliemae/ds-props-helpers';
import { propTypes, defaultProps, type DSFormLayoutCheckboxGroupT } from '../react-desc-prop-types.js';
import { DSFormLayoutCheckboxGroupName } from '../DSFormLayoutCheckboxGroupDefinitions.js';

interface UseFormLayoutCheckboxGroupT {
  propsWithDefault: DSFormLayoutCheckboxGroupT.InternalProps;
  globalAttributes: GlobalAttributesT;
  xstyledProps: XstyledProps;
}

export const useFormLayoutCheckboxGroup = (props: DSFormLayoutCheckboxGroupT.Props): UseFormLayoutCheckboxGroupT => {
  useValidateTypescriptPropTypes(props, propTypes, DSFormLayoutCheckboxGroupName);
  const propsWithDefault = useMemoMergePropsWithDefault<DSFormLayoutCheckboxGroupT.InternalProps>(props, defaultProps);
  const globalAttributes = useGetGlobalAttributes(propsWithDefault);

  const xstyledProps = useGetXstyledProps(propsWithDefault);
  return React.useMemo(
    () => ({ globalAttributes, xstyledProps, propsWithDefault }),
    [globalAttributes, xstyledProps, propsWithDefault],
  );
};
